import { apiClient } from './api';
import { logger } from '@/utils/logger';
import { Notification, NotificationResponse } from '@/types/notification';

export const notificationService = {
  // Get notifications
  async getNotifications(params?: {
    page?: number;
    limit?: number;
    unreadOnly?: boolean;
  }): Promise<NotificationResponse> {
    try {
      const response = await apiClient.get('/notifications', { params });
      return {
        notifications: response.data.data.map((n: any) => ({
          ...n,
          isRead: n.is_read,
          readAt: n.read_at,
          createdAt: n.created_at,
        })),
        pagination: response.data.meta,
        unreadCount: response.data.unreadCount,
      };
    } catch (error) {
      logger.error('Failed to fetch notifications', error);
      throw error;
    }
  },

  // Get unread count
  async getUnreadCount(): Promise<number> {
    try {
      const response = await apiClient.get('/notifications/unread-count');
      return response.data.data.count;
    } catch (error) {
      logger.error('Failed to fetch unread count', error);
      throw error;
    }
  },

  // Mark notification as read
  async markAsRead(notificationId: string): Promise<void> {
    try {
      await apiClient.patch(`/notifications/${notificationId}/read`);
    } catch (error) {
      logger.error('Failed to mark notification as read', error);
      throw error;
    }
  },

  // Mark all notifications as read
  async markAllAsRead(): Promise<void> {
    try {
      await apiClient.patch('/notifications/mark-all-read');
    } catch (error) {
      logger.error('Failed to mark all notifications as read', error);
      throw error;
    }
  },

  // Delete notification
  async deleteNotification(notificationId: string): Promise<void> {
    try {
      await apiClient.delete(`/notifications/${notificationId}`);
    } catch (error) {
      logger.error('Failed to delete notification', error);
      throw error;
    }
  },

  // Delete all notifications
  async deleteAllNotifications(): Promise<void> {
    try {
      await apiClient.delete('/notifications');
    } catch (error) {
      logger.error('Failed to delete all notifications', error);
      throw error;
    }
  },
};